namespace GeniuzPOS.SalePromoCamp {
    export class PsPromoHdColumns {
        static columnsKey = 'SalePromoCamp.PsPromoHd';
    }
}
